import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import PropTypes from 'prop-types';
import React from 'react';
import { css, px } from '@jd/jmtd-tools/es/css';
import { fromTo, reduce, take } from '@jd/jmtd-tools/es/generator';
import { top } from '@jd/jmtd-tools/es/array';
import classNames from '@jd/jmtd-tools/es/classnames';
import { setClass } from '@jd/jmtd-tools/es/element';
import { isNumber } from '@jd/jmtd-tools/es/is';
import Icon from '../Icon';
import Button from '../Button';
export var SCROLL_CONTENT = Symbol('scrollContent');
export var SCROLL_INDEX = Symbol('scrollIndex');
export var ACTIVE = Symbol('active');

function HorizontalScrollButton(_ref) {
  var disabled = _ref.disabled,
      start = _ref.start,
      end = _ref.end,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-tabs-scroll-button', 'jmtd-horizontal-tabs-scroll-button', {
      'jmtd-horizontal-tabs-scroll-button-start': start,
      'jmtd-horizontal-tabs-scroll-button-end': end,
      'jmtd-horizontal-tabs-scroll-button-disabled': disabled,
      'jmtd-horizontal-tabs-scroll-button-enabled': !disabled
    })
  }, /*#__PURE__*/React.createElement(Button, {
    semantic: "primary",
    link: true,
    dense: true,
    disabled: disabled,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      className: start ? 'jmti-angle-left' : 'jmti-angle-right'
    }),
    onClick: onClick
  }));
}

HorizontalScrollButton.propTypes = {
  disabled: PropTypes.bool,
  end: PropTypes.bool,
  start: PropTypes.bool,
  onClick: PropTypes.func
};
HorizontalScrollButton.defaultProps = {
  disabled: false,
  end: false,
  start: false,
  onClick: function onClick() {}
};
export function VerticalScrollButton(_ref2) {
  var disabled = _ref2.disabled,
      start = _ref2.start,
      end = _ref2.end,
      onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-tabs-scroll-button', 'jmtd-vertical-tabs-scroll-button', {
      'jmtd-vertical-tabs-scroll-button-start': start,
      'jmtd-vertical-tabs-scroll-button-end': end,
      'jmtd-vertical-tabs-scroll-button-disabled': disabled,
      'jmtd-vertical-tabs-scroll-button-enabled': !disabled
    })
  }, /*#__PURE__*/React.createElement(Button, {
    semantic: "primary",
    link: true,
    dense: true,
    disabled: disabled,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      className: start ? 'jmti-angle-up' : 'jmti-angle-down'
    }),
    onClick: onClick
  }));
}
VerticalScrollButton.propTypes = {
  disabled: PropTypes.bool,
  end: PropTypes.bool,
  start: PropTypes.bool,
  onClick: PropTypes.func
};
VerticalScrollButton.defaultProps = {
  disabled: false,
  end: false,
  start: false,
  onClick: function onClick() {}
};
export function TabsScrollContext(_ref3) {
  var self = _ref3.self,
      _ref3$margin = _ref3.margin,
      margin = _ref3$margin === void 0 ? 0 : _ref3$margin,
      getTabsWidth = _ref3.getTabsWidth,
      optionalScrollButtonWidth = _ref3.optionalScrollButtonWidth,
      _ref3$handleScroll = _ref3.handleScroll,
      handleScroll = _ref3$handleScroll === void 0 ? function () {} : _ref3$handleScroll,
      _ref3$callback = _ref3.callback,
      callback = _ref3$callback === void 0 ? function () {} : _ref3$callback;

  function update(activeIndex) {
    var scrollContent = self[SCROLL_CONTENT],
        ref = self.ref,
        tabsRef = self.tabsRef,
        _self$SCROLL_INDEX = self[SCROLL_INDEX],
        scrollIndex = _self$SCROLL_INDEX === void 0 ? 0 : _self$SCROLL_INDEX;

    if (!ref.offsetWidth) {
      return;
    }

    ref.classList.add('jmtd-tabs-test');
    setClass(ref, 'jmtd-tabs-scrolling', activeIndex == null);
    var tabsWidth = getTabsWidth(); // 计算每个tab的宽度

    var wrapperWidth = ref.offsetWidth;
    var scrollButtonWidth = 40;
    var maxScrollWidth = wrapperWidth - scrollButtonWidth;
    var tabsLength = tabsWidth.length; // 获取一个序列的宽度

    var getWidth = function getWidth(iterator) {
      return reduce(iterator, function (acc, index) {
        return acc + tabsWidth[index];
      }, 0);
    }; // 匹配宽度


    function matchWidth(start, step) {
      var marginLength = 0;
      var matchedWidth = tabsWidth[start];
      var end = step > 0 ? tabsLength : -1;

      var _iterator = _createForOfIteratorHelper(getWidth(fromTo(start, end, step))),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var width = _step.value;

          if (width + marginLength * margin > maxScrollWidth) {
            break;
          }

          matchedWidth = width;
          marginLength += 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return [_toConsumableArray(take(Math.max(marginLength, 1), fromTo(start, end, step))).sort(function (a, b) {
        return a - b;
      }), matchedWidth];
    }

    var _matchWidth = matchWidth(scrollIndex, 1),
        _matchWidth2 = _slicedToArray(_matchWidth, 2),
        currentMatch = _matchWidth2[0],
        matchedWidth = _matchWidth2[1];

    if (currentMatch.length < tabsLength) {
      // TAG 有滚动的情况
      ref.classList.add('jmtd-tabs-with-scroll'); // 激活元素如果不在当前可显范围内，调整scrollIndex

      if (activeIndex != null && !currentMatch.includes(activeIndex)) {
        var _matchWidth3 = matchWidth(activeIndex, 1);

        var _matchWidth4 = _slicedToArray(_matchWidth3, 2);

        currentMatch = _matchWidth4[0];
        matchedWidth = _matchWidth4[1];

        var _matchWidth5 = matchWidth(top(currentMatch), -1);

        var _matchWidth6 = _slicedToArray(_matchWidth5, 2);

        currentMatch = _matchWidth6[0];
        matchedWidth = _matchWidth6[1];
      }

      self[SCROLL_INDEX] = currentMatch[0];
    } else {
      // TAG 没有滚动的情况
      ref.classList.remove('jmtd-tabs-with-scroll');
      delete self[SCROLL_INDEX]; // 如果滚动宽度是可选的，此时最大滚动宽度中重新补回滚动按钮宽度

      if (optionalScrollButtonWidth) {
        maxScrollWidth += scrollButtonWidth;
      }
    }

    self.maxItemsCount = currentMatch.length;
    handleScroll({
      tabsWidth: tabsWidth,
      currentMatch: currentMatch,
      maxScrollWidth: maxScrollWidth,
      matchedWidth: matchedWidth
    });
    setClass(ref, 'jmtd-tabs-scroll-disable-start', currentMatch.includes(0));
    setClass(ref, 'jmtd-tabs-scroll-disable-end', currentMatch.includes(tabsLength - 1));
    ref.classList.remove('jmtd-tabs-test');
    callback();

    if (self[SCROLL_INDEX] != null) {
      css(scrollContent, 'transform', "translate3d(".concat(px(-tabsRef[self[SCROLL_INDEX]].offsetLeft), ",0,0)"));
    }
  }

  function scroll(step) {
    var tabsRef = self.tabsRef,
        _self$props = self.props,
        full = _self$props.full,
        fullScreenScroll = _self$props.fullScreenScroll,
        maxItemsCount = self.maxItemsCount;
    var tabsNumber = tabsRef.length;

    if (fullScreenScroll) {
      var scrollSize = isNumber(full) ? Math.min(tabsNumber, full) : maxItemsCount;
      self[SCROLL_INDEX] = Math.max(Math.min(tabsNumber - scrollSize, self[SCROLL_INDEX] + scrollSize * step), 0);
    } else {
      self[SCROLL_INDEX] += step;
    }
  }

  return {
    update: update,
    arrowLeft: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalScrollButton, {
      start: true,
      onClick: function onClick() {
        scroll(-1);
        update();
      }
    }), /*#__PURE__*/React.createElement(HorizontalScrollButton, {
      start: true,
      disabled: true
    })),
    arrowRight: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalScrollButton, {
      end: true,
      onClick: function onClick() {
        scroll(1);
        update();
      }
    }), /*#__PURE__*/React.createElement(HorizontalScrollButton, {
      end: true,
      disabled: true
    }))
  };
}